import { FuelEntries } from '../models/fuel.model';

export interface FuelState {
  data: FuelEntries | null;
  loading: boolean;
  error: string | null;
}

export const initialState: FuelState = {
  data: null,
  loading: false,
  error: null,
};
